import NavLink from '../navLink'

const GenDuo = ({ className = '', href = '/', color = '#999999' }) => (
  <NavLink className={`text-[${color}] text-sm font-alhpr ${className}`} to={href}>
    更多<span className="hidden lg:contents">{'>'}</span>
  </NavLink>
)

export default GenDuo
